import "@/App.css";
import "@fontsource/chivo/400.css";
import "@fontsource/chivo/600.css";
import "@fontsource/chivo/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import GlobalObservatory from "@/pages/GlobalObservatory";
import ConfirmedFeed from "@/pages/ConfirmedFeed";
import DamRecord from "@/pages/DamRecord";
import Leaderboard from "@/pages/Leaderboard";
import ScoringLedger from "@/pages/ScoringLedger";
import Outbox from "@/pages/Outbox";
import Embed from "@/pages/Embed";
import ManualConfirm from "@/pages/ManualConfirm";

function App() {
  return (
    <div className="App h-screen w-full">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GlobalObservatory />} />
          <Route path="/confirmed" element={<ConfirmedFeed />} />
          <Route path="/dam-record" element={<DamRecord />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/scoring" element={<ScoringLedger />} />
          <Route path="/outbox" element={<Outbox />} />
          <Route path="/embed" element={<Embed />} />
          <Route path="/manual-confirm" element={<ManualConfirm />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0D1117",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F0F6FC",
            fontFamily: "IBM Plex Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
